import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@auth0/auth0-angular';

import { Store } from '@ngrx/store';

import { ErrorActions } from '@actions/error.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatCard, MatCardContent, MatCardHeader } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { combineLatest, filter, interval } from 'rxjs';

@Component({
  selector: 'app-login-redirect',
  imports: [MatCard, MatCardContent, MatCardHeader, MatProgressSpinnerModule],
  templateUrl: './login-redirect.component.html',
  styleUrl: './login-redirect.component.scss',
})
export class LoginRedirectComponent {
  error?: string;
  errorDescription?: string;

  constructor(
    private auth: AuthService,
    private router: Router,
    private store: Store,
  ) {
    combineLatest([
      this.auth.isAuthenticated$,
      this.auth.isLoading$,
      this.auth.error$,
    ])
      .pipe(
        takeUntilDestroyed(),
        filter(([_isAuthenticated, _isLoading, error]) => !!error),
      )
      .subscribe(([_isAuthenticated, _isLoading, error]) => {
        console.log(
          'hit the error stuff! _isAuthenticated, _isLoading, error',
          _isAuthenticated,
          _isLoading,
          error,
        );

        if (error) {
          this.store.dispatch(
            ErrorActions.addIdPError({
              code: error.name,
              description: error.message,
            }),
          );
          this.router.navigate(['/error']);
        }
      });

    combineLatest([
      interval(1000),
      this.auth.isAuthenticated$,
      this.auth.isLoading$,
    ])
      .pipe(
        takeUntilDestroyed(),
        filter(
          ([waited, isAuthenticated, isLoading]) =>
            waited > 0 && waited % 5 === 0 && !!isAuthenticated && !isLoading,
        ),
      )
      .subscribe(() => {
        this.router.navigate(['/home/dashboard']);
      });
  }
}
